import {
  AmazonServices,
  FirstMileServices,
  UpsServices,
} from "@redotech/redo-model/fulfillments/fulfillment-carriers-and-services";
import { RateProvider } from "@redotech/redo-model/outbound-labels/outbound-labels";
import {
  RateTableType,
  RateTableValueMode,
} from "@redotech/redo-model/rate-table/rate-table";
import {
  FedexRateTableServiceLevel,
  RateTableCarrier,
  USPSRateTableServiceLevel,
} from "@redotech/redo-model/rate-table/rate-table-mapping";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

const baseDeleteRateTable = z.object({
  teamId: z.string().optional(),
  carrier: createEnum(RateTableCarrier).optional(),
  valueMode: createEnum(RateTableValueMode),
  rateTableType: createEnum(RateTableType),
  provider: createEnum(RateProvider).optional(),
  serviceLevel: z
    .union([
      z.union([createEnum(USPSRateTableServiceLevel), z.literal("Default")]),
      z.union([createEnum(FedexRateTableServiceLevel), z.literal("Default")]),
      z.union([createEnum(UpsServices), z.literal("Default")]),
      z.union([createEnum(AmazonServices), z.literal("Default")]),
      z.union([createEnum(FirstMileServices), z.literal("Default")]),
    ])
    .optional(),
});

export const deleteRateTable = {
  name: "deleteRateTable" as const,
  input: baseDeleteRateTable,
  output: z.object({ success: z.boolean() }),
};
